import {
  RPT_LOCATION_LISTING_SET_DATA,
  RPT_LOCATION_LISTING_ERROR,
  RPT_LOCATION_LISTING_IS_LOADING,
  RPT_LOCATION_LISTING_ON_SEARCH_CHANGE_DATA,
  RPT_LOCATION_LISTING_CLEAN_UP
} from '../../../constants/index';
import { initialRptLocationListingState } from '../initialReportState';

const rptLocationListingReducer = (state = initialRptLocationListingState, action) => {
  const { payload, type } = action;

  switch (type) {
    case RPT_LOCATION_LISTING_ERROR: {
      const { showMessage, errorMessage } = payload;
      return {
        ...state,
        isError: showMessage ? true : false,
        showMessage: showMessage,
        message: errorMessage
      };
    }
    case RPT_LOCATION_LISTING_SET_DATA: {
      const { resultData } = payload;

      return {
        ...state,
        rptList: resultData.reportData
      };
    }
    case RPT_LOCATION_LISTING_IS_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        isLoading: isLoading
      };
    }

    case RPT_LOCATION_LISTING_CLEAN_UP: {
      let { data } = payload;

      return {
        ...state,
        ...data
      };
    }

    case RPT_LOCATION_LISTING_ON_SEARCH_CHANGE_DATA: {
      let { data } = payload;

      return {
        ...state,
        filterOptions: {
          ...state.filterOptions,
          ...data
        }
      };
    }
    default:
      return state;
  }
};

export default rptLocationListingReducer;
